import React, { useEffect, useState } from 'react'
import CommonSelect from '@/components/common/select/commonSelect'
import api from "@/apis/pc/user/user";
import { getParameterByName } from "@/utils/utils";

// 员工下拉框
const CovPeopleSelect = (props) => {
  const initCondition = { name: '', pageNum: 1, pageSize: 50 }
  const { defaultValue, handleSuccess, handleBlur, checkValue, open, defaultData } = props;
  const [condition, setCondition] = useState(initCondition)
  const [hasNextPage, setHasNextPage] = useState(true)
  const [loading, setLoading] = useState(false)
  const initValue = [
    { label: '', arr: [] },
    { label: '异常用户', arr: [] }
  ]
  const [list, setList] = useState(initValue)
  let temp = initValue;

  const getData = async useDefaultData => {
    let type = 1
    let crmCustomerId = getParameterByName("id");
    let data = {};
    setLoading(true)
    if(useDefaultData){
      data = defaultData;
    }else{
      const res = await api.getCovUsers([]);
      data = res.data || [];
    }
    data?.forEach(item => {
      let arr = []
      let arrDimission = []
      let arrSessionType = []
      // 已离职
      const commonInfo = {
        id: item.uid,
        name: item.name,
        company: item.corpName,
        avatarUrl: item.avatarUrl,
        status:item.status,
        openChatSession : item.openChatSession,
      }
      // 不再需要分类
      arr.push(commonInfo)
      // 正常的项
      arr.length && temp[0].arr.push(...arr)
      // 异常的项
      if (arrDimission.length || arrSessionType.length) {
        temp[1].arr.push(...arrDimission, ...arrSessionType)
      }
    })
    setLoading(false)
    setList(temp)
    setHasNextPage(data?.length === condition.pageSize)
  }

  const handleConditionChange = (value) => {
    setCondition({ ...condition, ...value })
  }

  const reset = () => {
    setList(initValue)
    setCondition(initCondition)
  }

  useEffect(() => {
    if(JSON.stringify(initCondition) === JSON.stringify(condition)){
      getData(true)
    }else {
      getData()
    }
  }, [condition,defaultData])

  const getList = () => {
    if(condition?.name) {
      const name = condition?.name?.toLowerCase()
      const arr = []
      list?.forEach(item => {
        let newResult = {
          ...item,
          arr: item?.arr?.filter(arrItem => arrItem?.name?.toLowerCase().includes(name))
        }
        arr.push(newResult)
      })
      return arr
    }
    else {
      return list
    }
  }
  return (
    <div>
      <CommonSelect
        type={'group'}
        width={240}
        list={getList()}
        placeholder={'选择员工'}
        handleConditionChange={handleConditionChange}
        reset={reset}
        allowClear={false}
        defaultOpen={true}
        defaultValue={defaultValue || {}}
        condition={condition}
        checkValue={checkValue}
        open={open}
        initCondition={initCondition}
        hasNextPage={hasNextPage}
        handleSuccess={handleSuccess}
        handleBlur={() => handleBlur()}
        autoFocus={true}
        loading={loading}
      />
    </div>
  )
}

export default CovPeopleSelect